module.exports = __webpack_public_path__ + "img/skype.b75807b6.png";